import React from "react";
import "./kayttoehdot.m.css";


const KayttoehdotPage = () => {
  return (
    <div styleName="static-page-container">
      <style dangerouslySetInnerHTML={{
        __html: `
        .custom-hero-container-bg {
          background-image: url("/assets/static-header-desktop-hero.jpg?05082025");
        }
        @media (max-width: 767px) {
          .custom-hero-container-bg {
            background-image: url("/assets/static-header-mobile-hero.jpg?05082025");
          }
        }
      `}} />
      <div styleName="custom-hero-container" className="custom-hero-container-bg">
        <h1 styleName="custom-hero-heading">
          Tilaus- ja käyttöehdot
        </h1>
        <div styleName="bottomShadowContainer"></div>
      </div>
      <div styleName="custom-content-container">
        <p>Päivitetty: 20.3.2025</p>

        <h2>1. YLEISTÄ</h2>
        <p>Näitä ehtoja sovelletaan Dei Plus -suoratoistopalvelun ("Palvelu") tilauksiin ja käyttöön. "Asiakkaalla" ja ”Käyttäjällä” tarkoitetaan Palvelun tilaajaa.</p>
        <br />
        <p>Palvelua käyttävä henkilö (jäljempänä "Käyttäjä") vakuuttaa tutustuneensa ehtoihin ja sitoutuu kaikilta osin noudattamaan niitä sekä muita mahdollisia Palveluun liittyviä lisäehtoja ja ohjeita. Mikäli Tilaus- ja käyttöehdot ja erityisehdot ovat ristiriidassa, sovelletaan ensisijaisesti erityisehtoja.</p>
        <br />
        <p>Mikäli Palvelu on hankittu kolmannen osapuolen alustalta (esim. Google Play, App Store), sovelletaan lisäksi kyseisten palveluntarjoajien ehtoja.</p>

        <h2>2. PALVELUN TILAUSMUODOT</h2>
        <p>Palvelun käyttäminen edellyttää näiden tilaus- ja käyttöehtojen hyväksymistä. Sopimus syntyy, kun Asiakas hyväksyy tilausehdot ja vahvistaa tilauksen.</p>
        <h3>2.1. Sopimuksen voimassaolo</h3>


        <p>Sopimus on voimassa toistaiseksi ja se jatkuu ilman uudistamista,
          kunnes se irtisanotaan. Irtisanominen astuu voimaan kuluvan tilauskauden
          päätyttyä. Määräaikaiset tilaukset jatkuvat sopimuksen loppuun.</p>


        <h2>3. PALVELUN SISÄLTÖ JA KÄYTTÄMINEN</h2>
        <p>Dei Plus tarjoaa suoratoistosisältöjä, kuten podcasteja ja videopodeja. Palveluntarjoaja voi muuttaa saatavilla olevaa sisältöä ilman erillistä ilmoitusta.</p>
        <h3>3.1. Käyttöoikeus</h3>
        <p>Palvelun käyttöoikeus myönnetään asiakkaalle välittömästi maksun jälkeen. Palveluun ei liity fyysistä toimitusta, vaan sisältö on käytettävissä suoratoistona rekisteröityneenä käyttäjänä.</p>
        <h3>3.2. Päätelaitteet ja yhteensopivuus</h3>
        <p>Palvelua voi käyttää yhdellä laitteella kerrallaan, ellei toisin mainita. Palvelun käyttö edellyttää internet-yhteyttä ja yhteensopivaa laitetta.</p>

        <h2>4. MAKSUT JA IRTISANOMINEN</h2>
        <h3>4.1. Maksut</h3>
        <p>Palvelun tilaus veloitetaan kuukausittain tai tilauksen yhteydessä sovitulla tavalla. Maksutavat ja hinnasto on nähtävissä Dei Plus -palvelussa.</p>

        <h3> 4.2. Maksuehdot:</h3>
        <p> Maksupalveluntarjoaja</p>
        <p>
          Maksunvälityspalvelun toteuttajana ja maksupalveluntarjoajana toimii
          <strong> Paytrail Oyj</strong> (2122839-7) yhteistyössä suomalaisten pankkien ja luottolaitosten kanssa.
          Paytrail Oyj näkyy maksun saajana tiliotteella tai korttilaskulla ja välittää maksun kauppiaalle.
          Paytrail Oyj:llä on maksulaitoksen toimilupa. Reklamaatiotapauksissa pyydämme ottamaan ensisijaisesti
          yhteyttä tuotteen toimittajaan.
        </p>

        <p><strong>Paytrail Oyj, y-tunnus:</strong> 2122839-7</p>
        <p>
          Innova 2<br />
          Lutakonaukio 7<br />
          40100 Jyväskylä<br />
          <a href="https://www.paytrail.com" target="_blank" rel="noreferrer" styleName="paytrail-link">www.paytrail.com</a>
        </p>

        <h3>4.3. Peruutusoikeus</h3>
        <p>Koska palvelu on digitaalisesti käytettävissä heti maksun jälkeen, ei ostoilla ole palautusoikeutta. Tilaamalla hyväksyt, että kuuntelu- ja katseluoikeus alkaa heti, eikä tilausta voi perua tämän jälkeen.</p>
        <h3>4.4. Irtisanominen</h3>
        <p>Toistaiseksi voimassa olevan tilauksen voi irtisanoa Dei Plus –palvelussa tai asiakaspalvelun kautta. Määräaikaisia tilauksia ja kertatilauksia ei voi irtisanoa kesken tilauskauden. Irtisanomisen jälkeen tilaus jatkuu tilauskauden loppuun.</p>

        <h2>5. MAKSUTTOMAT KOKEILUJAKSOT</h2>
        <p>Uusille asiakkaille voidaan tarjota maksuton kokeilujakso. Jos tilausta ei peruuteta kokeilujakson aikana, se muuttuu maksulliseksi tilaukseksi.</p>

        <h2>6. KÄYTTÄJÄTILI JA TUNNUKSET</h2>
        <p>Palveluiden täysimääräinen käyttö ja tilaaminen edellyttää käyttäjätilin luomista ja kirjautumista. Käyttäjä vastaa tunnustensa turvallisuudesta ja on velvollinen ilmoittamaan mahdollisista väärinkäytöksistä palveluntarjoajalle. Käyttäjätunnukset ovat henkilökohtaisia, eikä niitä saa jakaa kolmansille osapuolille.</p>
        <p>Palveluntarjoajalla on oikeus sulkea käyttäjätili, jos sitä käytetään vilpillisesti tai ehtojen vastaisesti.</p>

        <h2>7. PALVELUN KÄYTTÖRAJOITUKSET</h2>
        <p>Käyttäjä ei saa kuormittaa Palvelua automaattisilla järjestelmillä (esim. botit ja spider-ohjelmat) eikä käyttää sitä datanlouhintaan tai tekoälymallien kouluttamiseen ilman erillistä lupaa.</p>
        <p>Palveluntarjoajalla on oikeus estää pääsy Palveluun, jos se häiritsee muuta verkkoliikennettä tai uhkaa tietoturvaa.</p>

        <h2>8. KOLMANNEN OSAPUOLEN PALVELUT</h2>
        <p>Kolmannen osapuolen palvelut (esim. App Store, Google Play, Kanavien sisällöt) voivat sisältää omia ehtojaan, jotka käyttäjän tulee hyväksyä.</p>

        <h2>9. PALKINNOT JA KILPAILUT</h2>
        <p>Palvelun yhteydessä voidaan järjestää arvontoja ja kilpailuja. Palkinnot voivat olla veronalaisia, ja järjestäjä varaa oikeuden muuttaa palkintoja ilman ennakkovaroitusta.</p>

        <h2>10. IMMATERIAALIOIKEUDET JA SISÄLLÖN KÄYTTÖ</h2>
        <p>Palvelun sisältö on suojattu tekijänoikeuslailla. Käyttäjä myöntää palveluntarjoajalle oikeuden käyttää Palveluun ladattua sisältöä journalistisiin ja kaupallisiin tarkoituksiin ilman erillistä korvausta.</p>

        <h2>11. TIETOSUOJA JA EVÄSTEET</h2>
        <p>Palveluntarjoaja voi tallentaa asiakaspalvelupuheluita ja käyttää käyttäjätietoja analytiikkaan ja mainonnan kohdentamiseen. Palvelu käyttää evästeitä käyttäjäkokemuksen parantamiseen.</p>

        <h2>12. RIIDAN RATKAISU JA SOVELLETTAVA LAKI</h2>
        <p>Näihin Käyttöehtoihin sovelletaan Suomen lakia. Kuluttajalla on oikeus viedä riita-asia kuluttajariitalautakuntaan tai Euroopan komission verkkovälitteiseen riidanratkaisupalveluun.</p>

        <h2>13. PALVELUN MUUTOKSET</h2>
        <p>Verkkopalveluiden tarjoaja pyrkii varmistamaan palveluiden jatkuvan saatavuuden ja virheettömän toiminnan, mutta ei voi taata niiden keskeytyksetöntä tai virheetöntä toimintaa. Verkkopalveluiden sisältöä ja ominaisuuksia voidaan muuttaa tai poistaa ilman ennakkoilmoitusta.</p>
        <p>Palveluntarjoaja voi muuttaa Käyttöehtoja ilmoittamalla siitä etukäteen. Käyttäjän tulee lopettaa Palvelun käyttö, jos hän ei hyväksy muutoksia.</p>

        <h2>YHTEYSTIEDOT</h2>
        <p>Kristillinen Media Oy, 1058141-9</p>
        <p>Dei Plus -asiakastuki</p>
        <p>Sähköposti: <a href="mailto:asiakastuki@deiplus.fi">asiakastuki@deiplus.fi</a></p>
      </div>
    </div>
  );
};

export { KayttoehdotPage };
